import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import ComplianceShell from 'features/compliance/ComplianceShell'
import ProgrammeBoard from 'features/compliance/ProgrammeBoard'

const ProgrammePage = ({ bpId: bpIdProp, embedded = false, onTabChange, chromeless = false } = {}) => {
  const routeParams = useParams()
  const bpId = bpIdProp ?? routeParams.bpId
  const [score, setScore] = useState(undefined)

  return (
    <ComplianceShell activeTab='programme' score={score} bpId={bpId} embedded={embedded} onTabChange={onTabChange} chromeless={chromeless}>
      <ProgrammeBoard
        bpId={bpId}
        onProgrammeLoaded={p => {
          const ready = p?.totals?.readiness ? p.totals.readiness.ready : true
          setScore(ready ? p?.totals?.score : undefined)
        }}
      />
    </ComplianceShell>
  )
}

export default ProgrammePage
